import { api } from "@/lib/api";

const DEFAULTS = [
  { key: "bronze",    label: "Bronze",     min_ovr: 0,  background_url: "/tier-bg/bronze.png",    accent_color: "" },
  { key: "silver",    label: "Silber",     min_ovr: 66, background_url: "/tier-bg/silver.png",    accent_color: "" },
  { key: "gold",      label: "Gold",       min_ovr: 76, background_url: "/tier-bg/gold.png",      accent_color: "" },
  { key: "whitegold", label: "White Gold", min_ovr: 86, background_url: "/tier-bg/whitegold.png", accent_color: "" },
  { key: "rookie",    label: "Rookie",     min_ovr: 0,  background_url: "/tier-bg/rookie.png",    accent_color: "" },
  { key: "champion",  label: "Champion",   min_ovr: 0,  background_url: "",                       accent_color: "#A855F7" },
];

let cache = null;
let pending = null;
const listeners = new Set();

export function getCachedTiers() {
  return cache || DEFAULTS;
}

export function fetchTiers(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (pending) return pending;
  pending = api.get("/tier-config")
    .then(({ data }) => {
      cache = (data?.tiers && data.tiers.length >= 5) ? data.tiers : DEFAULTS;
      listeners.forEach((cb) => cb(cache));
      return cache;
    })
    .catch(() => {
      cache = DEFAULTS;
      return cache;
    })
    .finally(() => { pending = null; });
  return pending;
}

export function subscribeTiers(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function invalidateTiers(newTiers) {
  if (newTiers && newTiers.length >= 5) {
    cache = newTiers;
    listeners.forEach((cb) => cb(cache));
  } else {
    cache = null;
    fetchTiers(true);
  }
}
